import { render, staticRenderFns } from "./ServicesPlan.vue?vue&type=template&id=0db79d5e&"
import script from "./ServicesPlan.vue?vue&type=script&lang=ts&"
export * from "./ServicesPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports